import React from 'react'
import PropTypes from 'prop-types'
import { LoaderButton, Flex, Box, Copy } from '@elparking/components'
import { FormattedMessage } from 'react-intl'
import { LocalForm, PasswordFieldConfirm } from '@elparking/form'
import { injectIntl, defineMessages } from 'react-intl'

const messages = defineMessages({
  passwordMatch: {
    defaultMessage: 'Las contraseñas deben coincidir.',
  },
})

class ResetPasswordUpdateForm extends React.Component {
  static propTypes = {
    errors: PropTypes.arrayOf(
      PropTypes.shape({
        message: PropTypes.string,
      })
    ),
    initialState: PropTypes.shape({
      promoCode: PropTypes.string,
    }),
    logo: PropTypes.node,
    loading: PropTypes.bool,
    onSubmit: PropTypes.func,
    renderReCaptcha: PropTypes.func,
    tradename: PropTypes.string.isRequired,
    success: PropTypes.bool,
    successImage: PropTypes.node,
    onReceiveError: PropTypes.func,
    intl: PropTypes.object,
  }

  static defaultProps = {
    errors: [],
    onSubmit: () => {},
    renderReCaptcha: () => {},
    onReceiveError: () => {},
  }

  state = {
    selectedCountry: {},
  }

  onResetPasswordSubmit(vals) {
    const { onSubmit, onReceiveError, intl } = this.props

    vals && vals.password === vals.passwordRepeat
      ? onSubmit(vals)
      : onReceiveError({
          field: 'passwordRepeat',
          message: intl.formatMessage(messages.passwordMatch),
        })
  }

  onResetPasswordSubmit = this.onResetPasswordSubmit.bind(this)

  render() {
    const {
      initialState,
      loading,
      logo,
      errors,
      renderReCaptcha,
      success,
      successImage,
    } = this.props

    const defaultState = { ...initialState }

    return (
      <Flex flexWrap="wrap" p="20px 50px">
        <Flex w="100%" p="10px 0 5px 0" justifyContent="center" mb="35px">
          {logo}
        </Flex>
        {success ? (
          <>
            <Flex width="100%" mb="24px" justifyContent="center">
              {successImage}
            </Flex>
            <Box mb="16px">
              <Copy padding="0" size="medium" fontWeight="book" align="center">
                <FormattedMessage defaultMessage="Tu contraseña se ha cambiado correctamente." />
              </Copy>
            </Box>
          </>
        ) : (
          <Box w="100%">
            <LocalForm
              model="resetPasswordUpdate"
              onSubmit={this.onResetPasswordSubmit}
              initialState={(values) => ({
                ...defaultState,
                ...values,
              })}
              getDispatch={(dispatch) => (this.formDispatch = dispatch)}
            >
              <Box mb="16px">
                <Copy
                  padding="0"
                  size="medium"
                  fontWeight="book"
                  align="center"
                >
                  <FormattedMessage defaultMessage="Introduce tu nueva contraseña." />
                </Copy>
              </Box>
              {errors.length > 0 && (
                <Box mb="8px" w="100%">
                  <Copy
                    padding="0"
                    color="red"
                    size="small"
                    fontWeight="regular"
                  >
                    {errors.map(({ message }) => message).join(',')}
                  </Copy>
                </Box>
              )}
              <Box w="100%" flex="1 0 100%" mb="12px">
                <PasswordFieldConfirm dataTest="reset-password-field" />
              </Box>
              <LoaderButton
                formNoValidate
                loading={loading}
                model="resetPasswordUpdate"
                width="100%"
              >
                <FormattedMessage defaultMessage="Guardar nueva contraseña" />
              </LoaderButton>
              <Box>{renderReCaptcha()}</Box>
            </LocalForm>
          </Box>
        )}
      </Flex>
    )
  }
}

export default injectIntl(ResetPasswordUpdateForm)
